module.exports = __webpack_public_path__ + "static/media/SofiaProBlackItalic.b748649c.otf";